// extracted by mini-css-extract-plugin
module.exports = {"footer":"w_bw","footerWrapper":"w_bx","companyAddress":"w_by","siteInfo":"w_bz","copyright":"w_bB","copyrightImage":"w_bC"};